module.exports = __webpack_public_path__ + "img/2024big26.42071297.png";